// extracted by mini-css-extract-plugin
export var resizer = "_eq-0";